import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { H1 } from 'components/common/Text/Text'
import Mixin from 'components/common/Mixin'

const BOTCreditCard = ({ title, placeholders: { content = []} = {}}) =>
  <Wrapper>
    {
      title &&
      <Title headline> { title } </Title>
    }
    { content }
  </Wrapper>

BOTCreditCard.propTypes = {
  placeholders: PropTypes.shape({
    content: PropTypes.array
  }),
  title: PropTypes.string
}

export default BOTCreditCard

const Wrapper = styled.div`
  ${Mixin.responsive('padding', '50px 0 0', '16px 16px 0')};
`

const Title = styled(H1)`
  ${Mixin.responsive('font-size', '40px', '30px')}
`
